let compareLs = window.localStorage.getItem('compare');
let compareItems = {};
let compareIds = [];
if (compareLs !== null) {
  compareItems = JSON.parse(compareLs);
  compareIds = Object.keys(compareItems);
}
const compareSelector = '[data-entity="compare-checkbox"]';
const CompareUpdate = new CustomEvent('CompareUpdate');

const setActiveCompareIcons = () => {
  const inputs = document.querySelectorAll(compareSelector);
  inputs.forEach((el) => {
    const id = el.dataset.id;
    const isActive = compareIds.includes(id);
    if (isActive) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  });
};
const setCompareItems = (result) => {
  compareItems = result;
  window.localStorage.setItem('compare', JSON.stringify(compareItems));
  window.dispatchEvent(CompareUpdate);
  compareIds = Object.keys(compareItems);
  queueMicrotask(() => {
    setActiveCompareIcons();
  });
};
window.updateComparesItems = setCompareItems;

const updateCompareItems = async () => {
  const queryString = new URLSearchParams({
    itemsIds: JSON.stringify(compareIds),
  });
  const response = await fetch(`/local/ajax/compare/updateItems.php?${queryString}`, {
    method: 'POST',
  });
  if (response.ok) {
    const result = await response.json();
    if (Array.isArray(result) && !result.length) {
      const modalWrapper = document.querySelector('[data-list-type="jsCompareProduct"]');

      if (modalWrapper) {
        modalWrapper.classList.remove('_with-popup--active');

        const modal = modalWrapper.querySelector('.buttons-bottom-header__item-popup');
        modal.style.display = 'none';
        setTimeout(() => {
          modal.style.display = 'block';
        }, 550);
      }
    }
    setCompareItems(result);
  }
};
if (compareLs === null) {
  updateCompareItems();
}

const addCompareItem = async (id) => {
  compareIds.push(id);
  updateCompareItems();
};
const deleteCompareItem = async (id) => {
  const i = compareIds.indexOf(id);
  if (i >= 0) {
    compareIds.splice(i, 1);
  }
  updateCompareItems();
};
const changeCompareItem = (el) => {
  const id = el.dataset.id;
  const inList = Array.isArray(compareIds) ? compareIds.includes(id) : false;
  if (inList) {
    deleteCompareItem(id);
    return;
  }
  addCompareItem(id);
};
const addHandlerClickOnCompareIcon = (withUniqueCheck = false) => {
  const inputs = document.querySelectorAll(compareSelector);
  inputs.forEach((el) => {
    if (el.classList.contains('init') && !withUniqueCheck) return;

    el.addEventListener('click', () => {
      changeCompareItem(el);
    });
    el.classList.add('init');
  });
};

setActiveCompareIcons();
addHandlerClickOnCompareIcon();

let oldCompareList = JSON.parse(compareLs);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible' && window?.location?.pathname.startsWith('/catalog/compare.php')) {
    const newCompareList = JSON.parse(window.localStorage.getItem('compare'));

    if (Object.keys(oldCompareList).length !== Object.keys(newCompareList).length) {
      compareIds = Object.keys(newCompareList);
      window.makeRequest('', true);
      oldCompareList = newCompareList;
    }
  }
});

window.updateCompare = () => {
  compareLs = window.localStorage.getItem('compare');
  compareItems = JSON.parse(compareLs);
  compareIds = Object.keys(compareItems || {});
  setActiveCompareIcons();
};

window.deleteCompareItem = deleteCompareItem;
window.addHandlerClickOnCompareIcon = addHandlerClickOnCompareIcon;
window.setActiveCompareIcons = setActiveCompareIcons;

export { setActiveCompareIcons, addHandlerClickOnCompareIcon };
